import { audio } from "../audio/audio";
import { HapticGate, hapticFor } from "../audio/hapticCues";
import { haptics } from "../infra/platform/haptics";
import { Settings, onSettingsChange, setHapticsAvailable } from "../ui/settings";
import type { Feature } from "./registry";

/** Seconds on the page's monotonic clock, for the haptic rate limit. */
const MS_PER_SECOND = 1000;

/**
 * Haptics in play (FINISH_PLAN WP10, S5): the platform adapter (WP4, infra/platform/haptics.ts) felt through the cues
 * the sound port plays (audio/hapticCues.ts), behind Settings → Haptics. The row shows only where the platform has
 * haptics: the iOS shell's Taptic Engine, the Vibration API, or iOS Safari's switch-control tick, which WebKit gives
 * only inside a tap (so on the iOS web a build or a trade is felt, a leak or a win between taps is not).
 */
export const hapticsFeature: Feature = {
  id: "haptics",
  register() {
    setHapticsAvailable(haptics.available);
    const sync = () => { haptics.enabled = Settings.current.haptics; };
    sync();
    onSettingsChange(sync);
    const gate = new HapticGate();
    audio.onCue((cue) => {
      const kind = hapticFor(cue);
      if (kind && haptics.enabled && gate.admit(kind, performance.now() / MS_PER_SECOND)) haptics.play(kind);
    });
  },
};
